/**
 * ShopSalesDashboard Presenter
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 11 금요일
 * 마지막 수정일 - 2025 07 11 금요일
 */
import React from 'react';
import { Content, Row, Col, Title } from 'components';
import { Spin } from 'antd';
import dayjs from 'dayjs';
import ShopSalesStatus from './components/ShopSalesStatus';
import ShopSalesCompany from './components/ShopSalesCompany';
import ShopSalesDaily from './components/ShopSalesDaily';

const ShopSalesDashboardPresenter = (props) => {
  /**
   * SECTION - Init
   */

  /**!SECTION - Init */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Props
   */
  const {
    isLoading = false,
    auth = 'SHOP',
    shopInformation = [],
    selectedShop = null,
    orders = [],
    orderList = {
      delivery: [],
      subscription: [],
      rental: [],
    },
    period = 7,
  } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Variable
   */

  /**!SECTION - Variable */

  /**
   * SECTION - Query Data
   */

  /**!SECTION - Query Data */

  /**
   * SECTION - Mutate
   */

  /**!SECTION - Mutate */

  /**
   * SECTION - State
   */

  /**!SECTION - State */

  /**
   * SECTION - Function
   */

  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */
  // 오늘 매출 정제
  const TodaySales = React.useMemo(() => {
    if (auth !== 'ADMIN' && !selectedShop)
      return {
        delivery: [],
        subscription: [],
        rental: [],
        orders: [],
      };

    const todayStart = dayjs().startOf('day').unix();
    const todayEnd = dayjs().endOf('day').unix();

    const todayList = {
      delivery:
        orderList?.delivery?.filter(
          (order) =>
            (auth === 'ADMIN'
              ? true
              : order.shop_information_id === selectedShop) &&
            order.payment_date >= todayStart &&
            order.payment_date <= todayEnd
        ) ?? [],
      subscription:
        orderList?.subscription?.filter(
          (order) =>
            (auth === 'ADMIN'
              ? true
              : order.shop_information_id === selectedShop) &&
            order.regular_payment_info.payment_date >= todayStart &&
            order.regular_payment_info.payment_date <= todayEnd
        ) ?? [],
      rental:
        orderList?.rental?.filter(
          (order) =>
            (auth === 'ADMIN'
              ? true
              : order.shop_information_id === selectedShop) &&
            order.rental_payment_info.payment_date >= todayStart &&
            order.rental_payment_info.payment_date <= todayEnd
        ) ?? [],
      orders:
        orders?.filter(
          (order) =>
            (auth === 'ADMIN'
              ? true
              : order.shop_information_id === selectedShop) &&
            order.payment_completion_date >= todayStart &&
            order.payment_completion_date <= todayEnd
        ) ?? [],
    };

    return todayList;
  }, [auth, selectedShop, orderList, orders]);
  /**!SECTION - Hooks */

  /**
   * SECTION - Render
   */
  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content maxWidth={'100%'} backgroundColor={'none'} padding={20}>
          <Row gutter={[16, 16]}>
            <Col x={24}>
              <Title
                size={3}
                style={{ marginBottom: 12 }}
                subButton={
                  <span
                    style={{
                      color: '#717171',
                      fontWeight: 400,
                      fontSize: '0.85em',
                    }}
                  >
                    {dayjs().locale('ko').format('YYYY년 MM월 DD일(ddd)')}
                  </span>
                }
              >
                대시보드
              </Title>
            </Col>

            <Col x={24}>
              <ShopSalesStatus data={TodaySales} />
            </Col>
            {auth === 'ADMIN' ? (
              <Col x={24}>
                <ShopSalesCompany
                  shops={shopInformation}
                  period={period}
                  orders={orders}
                  delivery={orderList.delivery}
                  subscription={orderList.subscription}
                  rental={orderList.rental}
                />
              </Col>
            ) : null}

            <Col x={24}>
              <ShopSalesDaily
                period={period}
                orders={orders}
                delivery={orderList.delivery}
                subscription={orderList.subscription}
                rental={orderList.rental}
              />
            </Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
  /**!SECTION - Render */
};

export default ShopSalesDashboardPresenter;
